import _ from "lodash";
export const getCommentsKey = ({ commentsKey, isCommunity }) => {
  if (!_.isEmpty(commentsKey)) {
    return commentsKey;
  }
  if (isCommunity) {
    return "communityComments";
  }
  return "comments";
};
